import subsetNames from './material-symbols-subset-names.json';
const SUBSET_NAMES = new Set(subsetNames);
/** `yarn icons:subset` regenerates this list together with the subset font. */
export const isInMaterialSymbolsSubset = (name) => SUBSET_NAMES.has(name);
